// Constants
const { GATSBY_COUNTRY } = process.env;

/**
 * Obtiene el país actual desde las variables de entorno
 * @returns {string} Código del país (CO, MX)
 */
const getCountry = () => process.env.GATSBY_COUNTRY || 'CO';

/**
 * Constantes para property_moment
 */
const processingMoment = 3; // Inmueble en proceso de registro

/**
 * Constantes para inventory_type
 */
const sustainableMoment = 3; // Inventario sostenible

/**
 * Configuración por país
 * Las variables de entorno de MX usan prefijo _MX (ej: GATSBY_LISTING_URL_MX)
 * Las variables de entorno de CO no usan prefijo (ej: GATSBY_HABI_API_URL_V2)
 */
const COUNTRIES = {
  CO: {
    LABEL: 'CO',
    // API Base URL
    HABI_API_URL_V2: process.env.GATSBY_HABI_API_URL_V2,
    // Listing API
    LISTING_API_URL: process.env.GATSBY_HABI_API_URL_V2,
    LISTING_API_KEY: process.env.GATSBY_FILTERS_LISTING_API_KEY,
    // Paths y endpoints (hardcodeados, no sensibles)
    LISTING_API_FILTERS_BASE_PATH: 'listing-global-api/',
    GET_FILTERS_ENDPOINT: 'get_filters',
    GET_PROPERTIES_ENDPOINT: 'get_properties',
    GET_PROPERTIES_AROUND_ENDPOINT: 'get_properties_around',
    // HubSpot API
    HUBSPOT_API_KEY: process.env.GATSBY_HUBSPOT_MAIN_API_KEY,
    HUBSPOT_BASE_PATH: 'hubspot-main-api/',
    HUBSPOT_CREATE_CONTACT_ENDPOINT: 'api_create_contact_and_deal',
    // Forms API
    FORMS_API_KEY: process.env.GATSBY_FORMS_API_KEY,
    FORMS_API_BASE_PATH: 'habi-api-forms/',
    FORMS_POST_TERMS_ENDPOINT: 'post_terms',
    // Property Card API
    PROPERTY_CARD_URL: process.env.GATSBY_GET_PROPERTIE_ENDPOINT_URL,
    PROPERTY_CARD_API_KEY: process.env.GATSBY_GET_PROPERTIE_API_KEY,
    // Google Maps
    GOOGLE_MAPS_KEY: process.env.GATSBY_GOOGLE_MAPS_KEY,
    // Bucket de imágenes
    BUCKET_IMG: process.env.GATSBY_BUCKET_IMG,
    // URLs
    URL_HABI: process.env.GATSBY_URL_HABI,
    TERMS_AND_CONDITIONS: process.env.GATSBY_TERMS_AND_CONDITIONS_URL,
    PRIVACY_POLICIES: process.env.GATSBY_PRIVACY_POLICIES_URL,
    // Strapi
    STRAPI_URL: process.env.GATSBY_NEW_STRAPI_URL,
    STRAPI_PROJECT: process.env.STRAPI_PROJECT,
    STRAPI_PROJECT_BROKERS: process.env.STRAPI_PROJECT_BROKERS,
    STRAPI_PAGE_OFERTON: process.env.STRAPI_PAGE_OFERTON,
    // Analytics
    GOOGLE_ANALYTICS: process.env.GATSBY_HABI_GOOGLE_ANALYTICS,
    TAG_MANAGER: process.env.GATSBY_HABI_TAG_MANAGER,
    SEGMENT_KEY: process.env.GATSBY_SEGMENT_KEY,
    GTM_ID: process.env.GATSBY_HABI_GTM_ID,
    // Para compatibilidad con gatsby-source-apiserver
    ENTITY_LEVEL: 'messagge',
  },
  MX: {
    LABEL: 'MX',
    // API Base URL - con prefijo _MX
    HABI_API_URL_V2: process.env.GATSBY_HABI_API_URL_V2_MX,
    // Listing API - con prefijo _MX
    LISTING_API_URL: process.env.GATSBY_LISTING_URL_MX,
    LISTING_API_KEY: process.env.GATSBY_LISTING_API_KEY_MX,
    // Paths y endpoints (hardcodeados, no sensibles)
    LISTING_API_FILTERS_BASE_PATH: null, // MX no usa base path adicional
    GET_FILTERS_ENDPOINT: 'get_filters',
    GET_PROPERTIES_ENDPOINT: 'get_properties',
    GET_PROPERTIES_AROUND_ENDPOINT: 'get_properties_around',
    // HubSpot API - con prefijo _MX
    HUBSPOT_API_KEY: process.env.GATSBY_HUBSPOT_MAIN_API_KEY_MX,
    HUBSPOT_BASE_PATH: 'hubspot-main-api/',
    HUBSPOT_CREATE_CONTACT_ENDPOINT: 'api_create_contact_and_deal',
    // Forms API - con prefijo _MX
    FORMS_API_KEY: process.env.GATSBY_FORMS_API_KEY_MX,
    FORMS_API_BASE_PATH: 'habi-api-forms/',
    FORMS_POST_TERMS_ENDPOINT: 'post_terms',
    // Property Card API - con prefijo _MX
    PROPERTY_CARD_URL: process.env.GATSBY_GET_PROPERTIE_ENDPOINT_URL_MX,
    PROPERTY_CARD_API_KEY: process.env.GATSBY_GET_PROPERTIE_API_KEY_MX,
    // Google Maps - con prefijo _MX
    GOOGLE_MAPS_KEY: process.env.GATSBY_GOOGLE_MAPS_KEY_MX,
    // Bucket de imágenes - con prefijo _MX
    BUCKET_IMG: process.env.GATSBY_BUCKET_IMG_MX,
    // URLs - con prefijo _MX
    URL_HABI: process.env.GATSBY_URL_HABI_MX,
    TERMS_AND_CONDITIONS: process.env.GATSBY_TERMS_AND_CONDITIONS_MX,
    PRIVACY_POLICIES: process.env.GATSBY_PRIVACY_POLICIES_URL_MX,
    // Strapi - con prefijo _MX
    STRAPI_URL: process.env.GATSBY_NEW_STRAPI_URL_MX,
    STRAPI_PROJECT: process.env.STRAPI_PROJECT_MX,
    STRAPI_PROJECT_BROKERS: process.env.STRAPI_PROJECT_BROKERS_MX,
    STRAPI_PAGE_OFERTON: process.env.STRAPI_PAGE_OFERTON_MX,
    // Analytics - con prefijo _MX
    GOOGLE_ANALYTICS: process.env.GATSBY_HABI_GOOGLE_ANALYTICS_MX,
    TAG_MANAGER: process.env.GATSBY_HABI_TAG_MANAGER_MX,
    SEGMENT_KEY: process.env.GATSBY_SEGMENT_KEY_MX,
    GTM_ID: process.env.GATSBY_HABI_GTM_ID_MX,
    // Para compatibilidad con gatsby-source-apiserver
    ENTITY_LEVEL: null,
  },
};

const formatMoney = (amount) => {
  if (GATSBY_COUNTRY === 'MX') {
    return Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
    }).format(amount);
  }

  return Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(amount);
};

const cleanAccents = (str) =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_')
    .toLowerCase();

// Caracteres que rompen rutas de artefacto (upload-artifact/NTFS) y segmentos URL
const INVALID_PATH_CHARS = /[\r\n\t\0"<>|*?:/\\]/g;

/**
 * Normaliza un slug para rutas de ficha (mismo criterio que createPage en gatsby-node).
 * @param {string|number|null|undefined} slug
 * @returns {string}
 */
const cleanUrl = (slug) => {
  if (slug == null) return '';

  return String(slug)
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(INVALID_PATH_CHARS, '')
    .replace(/_/g, '-')
    .replace(/ /g, '-')
    .replace(/-+/g, '-')
    .replace(/(?:^-)|(?:-$)/g, '');
};

const getImageThumbnail = (image, size = 414, webp = true) => {
  const imageName = image ? image.split('.')[0] : '';
  const imageExt = image ? image.split('.')[1] : '';

  return `${imageName}-${size}.${imageExt}${webp ? '?d=400x400' : ''}`;
};

function isObject(object) {
  return object != null && typeof object === 'object';
}

function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  return keys1.every((key) => {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    return (
      (areObjects && deepEqual(val1, val2)) ||
      (!areObjects && val1 === val2)
    );
  });
}

const parceCleanString = (str) => str?.toLowerCase().trim();

const getHashed = async ({ algorithm = 'SHA-256', str }) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest(algorithm, data);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};

/**
 * Obtiene la configuración de la API de listings según el país
 * @returns {Array} [baseURL, apiKey]
 */
const getListingApiConfig = () => {
  const currentCountry = getCountry();
  const {
    LISTING_API_URL,
    LISTING_API_KEY,
    GET_PROPERTIES_ENDPOINT,
    LISTING_API_FILTERS_BASE_PATH,
  } = COUNTRIES[currentCountry];

  const baseURL = LISTING_API_FILTERS_BASE_PATH
    ? `${LISTING_API_URL}${LISTING_API_FILTERS_BASE_PATH}${GET_PROPERTIES_ENDPOINT}`
    : `${LISTING_API_URL}${GET_PROPERTIES_ENDPOINT}`;
  return [baseURL, LISTING_API_KEY];
};

/**
 * Obtiene la configuración de la API de filtros según el país
 * @returns {Array} [baseURL, apiKey]
 */
const getFiltersApiConfig = () => {
  const currentCountry = getCountry();
  const {
    LISTING_API_URL,
    LISTING_API_KEY,
    GET_FILTERS_ENDPOINT,
    LISTING_API_FILTERS_BASE_PATH,
  } = COUNTRIES[currentCountry];

  const baseURL = LISTING_API_FILTERS_BASE_PATH
    ? `${LISTING_API_URL}${LISTING_API_FILTERS_BASE_PATH}${GET_FILTERS_ENDPOINT}`
    : `${LISTING_API_URL}${GET_FILTERS_ENDPOINT}`;

  return [baseURL, LISTING_API_KEY];
};

/**
 * Obtiene la configuración de Strapi según el país
 * @returns {Object} Configuración de Strapi
 */
const getStrapiConfig = () => {
  const currentCountry = getCountry();
  const {
    STRAPI_URL,
    STRAPI_PROJECT,
    STRAPI_PROJECT_BROKERS,
    STRAPI_PAGE_OFERTON,
  } = COUNTRIES[currentCountry];

  return {
    url: STRAPI_URL,
    project: STRAPI_PROJECT,
    project_brokers: STRAPI_PROJECT_BROKERS,
    page_oferton: STRAPI_PAGE_OFERTON,
    country: currentCountry,
  };
};

/**
 * Obtiene la configuración de HubSpot según el país
 * @returns {Array} [baseURL, apiKey]
 */
const getHubSpotApiConfig = () => {
  const currentCountry = getCountry();
  const {
    HABI_API_URL_V2,
    HUBSPOT_API_KEY,
    HUBSPOT_BASE_PATH,
    HUBSPOT_CREATE_CONTACT_ENDPOINT,
  } = COUNTRIES[currentCountry];

  const baseURL = `${HABI_API_URL_V2}${HUBSPOT_BASE_PATH}${HUBSPOT_CREATE_CONTACT_ENDPOINT}`;
  return [baseURL, HUBSPOT_API_KEY];
};

/**
 * Obtiene la configuración de Forms API según el país
 * @returns {Array} [baseURL, apiKey]
 */
const getFormsApiConfig = () => {
  const currentCountry = getCountry();
  const {
    HABI_API_URL_V2,
    FORMS_API_KEY,
    FORMS_API_BASE_PATH,
    FORMS_POST_TERMS_ENDPOINT,
  } = COUNTRIES[currentCountry];

  const baseURL = `${HABI_API_URL_V2}${FORMS_API_BASE_PATH}${FORMS_POST_TERMS_ENDPOINT}`;
  return [baseURL, FORMS_API_KEY];
};

/**
 * Obtiene la configuración de Property Card API según el país
 * @returns {Array} [url, apiKey]
 */
const getPropertyCardApiConfig = () => {
  const currentCountry = getCountry();
  const {
    PROPERTY_CARD_URL,
    PROPERTY_CARD_API_KEY,
  } = COUNTRIES[currentCountry];

  return [PROPERTY_CARD_URL, PROPERTY_CARD_API_KEY];
};

/**
 * Obtiene la URL del bucket de imágenes según el país
 * @returns {string} URL del bucket
 */
const getBucketImg = () => {
  const currentCountry = getCountry();
  return COUNTRIES[currentCountry].BUCKET_IMG;
};

/**
 * Obtiene la URL principal de Habi según el país
 * @returns {string} URL de Habi
 */
const getUrlHabi = () => {
  const currentCountry = getCountry();
  return COUNTRIES[currentCountry].URL_HABI;
};

const LISTING_PATH_BY_COUNTRY = {
  CO: 'venta-apartamentos',
  MX: 'propiedades',
};

/**
 * Obtiene el path base del listing de inmuebles según el país
 * @returns {string} Path sin slashes (ej: 'venta-apartamentos' o 'propiedades')
 */
const getListingPath = () => LISTING_PATH_BY_COUNTRY[getCountry()];

/**
 * Obtiene la URL de términos y condiciones según el país
 * @returns {string} URL de términos y condiciones
 */
const getTermsAndConditions = () => {
  const currentCountry = getCountry();
  return COUNTRIES[currentCountry].TERMS_AND_CONDITIONS;
};

/**
 * Obtiene la URL de políticas de privacidad según el país
 * @returns {string} URL de políticas de privacidad
 */
const getPrivacyPolicies = () => {
  const currentCountry = getCountry();
  return COUNTRIES[currentCountry].PRIVACY_POLICIES;
};

/**
 * Obtiene la clave de Google Maps según el país
 * @returns {string} Clave de Google Maps
 */
const getGoogleMapsKey = () => {
  const currentCountry = getCountry();
  return COUNTRIES[currentCountry].GOOGLE_MAPS_KEY;
};

/**
 * Obtiene la configuración de Analytics según el país
 * @returns {Object} Configuración de Analytics
 */
const getAnalyticsConfig = () => {
  const currentCountry = getCountry();
  const {
    GOOGLE_ANALYTICS,
    TAG_MANAGER,
    SEGMENT_KEY,
    GTM_ID,
  } = COUNTRIES[currentCountry];

  return {
    GOOGLE_ANALYTICS,
    TAG_MANAGER,
    SEGMENT_KEY,
    GTM_ID,
  };
};

/**
 * Obtiene la configuración para getPropertiesAround según el país
 * @returns {Object} Configuración con URL, API_KEY y endpoint
 */
const getPropertiesAroundConfig = () => {
  const currentCountry = getCountry();
  const {
    LISTING_API_URL,
    LISTING_API_KEY,
    GET_PROPERTIES_AROUND_ENDPOINT,
    LISTING_API_FILTERS_BASE_PATH,
  } = COUNTRIES[currentCountry];

  const baseURL = LISTING_API_FILTERS_BASE_PATH
    ? `${LISTING_API_URL}${LISTING_API_FILTERS_BASE_PATH}${GET_PROPERTIES_AROUND_ENDPOINT}`
    : `${LISTING_API_URL}${GET_PROPERTIES_AROUND_ENDPOINT}`;

  return {
    url: baseURL,
    apiKey: LISTING_API_KEY,
  };
};

// Exportaciones CommonJS para compatibilidad con gatsby-config.js, gatsby-node.js y componentes React
module.exports = {
  getCountry,
  processingMoment,
  sustainableMoment,
  COUNTRIES,
  formatMoney,
  cleanAccents,
  cleanUrl,
  getImageThumbnail,
  deepEqual,
  parceCleanString,
  getHashed,
  getListingApiConfig,
  getFiltersApiConfig,
  getStrapiConfig,
  getHubSpotApiConfig,
  getFormsApiConfig,
  getPropertyCardApiConfig,
  getPropertiesAroundConfig,
  getBucketImg,
  getUrlHabi,
  getListingPath,
  getTermsAndConditions,
  getPrivacyPolicies,
  getGoogleMapsKey,
  getAnalyticsConfig,
};
